import { Search } from 'lucide-react'
import { Link } from 'react-router'
import { useRootLoader } from '#app/utils/app.js'
import { ThemeSwitch } from '../routes/resources+/theme-switch.tsx'
import { AppCommandDialog } from './command-dialog'
import Logo from './logo.tsx'
import { AppNavigationMenu } from './navigation.tsx'
import { buttonVariants } from './ui/button.tsx'
import { UserDropdown } from './user-dropdown.tsx'

export default function AppHeader({
	isOnboardingComplete,
	commandDialog = true,
	navigation = true,
}: {
	isOnboardingComplete?: boolean
	commandDialog?: boolean
	navigation?: boolean
}) {
	const rootData = useRootLoader()
	const isAdmin = rootData.isAdmin
	
	
	// Only show navigation if specifically requested AND onboarding is complete
	const showNavigation = navigation && isOnboardingComplete && rootData.user

	return (
		<>
			{/* Role-playing indicator banner */}
			{rootData.user?.isImpersonating && (
				<div className="bg-amber-100 border-b border-amber-200 py-2">
					<div className="container flex items-center justify-between">
						<div className="flex items-center gap-2 text-amber-800">
							<svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z" />
							</svg>
							<span className="font-medium">
								Role-Playing Mode: You are currently viewing the system as a user with the <strong>{rootData.user.impersonatedRoleName}</strong> role
							</span>
						</div>
						<form action="/action/role-play" method="POST" className="flex items-center gap-2">
							<input type="hidden" name="intent" value="stop-role-play" />
							<span className="text-sm text-amber-700">Actual user: {rootData.user.actualUsername}</span>
							<button 
								type="submit" 
								className="text-sm bg-amber-200 hover:bg-amber-300 text-amber-800 px-3 py-1 rounded-md transition-colors"
							>
								Stop Role-Playing
							</button>
						</form>
					</div>
				</div>
			)}
			
			<header className="container py-6">
				<nav className="flex flex-wrap items-center justify-between gap-4 sm:flex-nowrap md:gap-8">
					<div>
					<Logo />
					<span className='text-sm font-medium ml-1'>({rootData.tenantId})</span>
					</div>
					{showNavigation ? <AppNavigationMenu /> : null}

					<div className="flex items-center gap-4">
						{rootData.user ? (
							<>
								{/* {commandDialog ? <AppCommandDialog /> : null} */}
								{commandDialog ? <AppCommandDialog /> : null}
								<div className="hidden items-center gap-2 text-sm text-muted-foreground md:flex">
									<Search className="h-4 w-4" />
									<span>Press</span>
									<kbd className="pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100">
										<span className="text-xs">⌘</span>K
									</kbd>
								</div>
								{isAdmin && isOnboardingComplete ? (
									<Link
										to={'/admin'}
										className={buttonVariants({ variant: 'default' })}
									>
										Admin Portal
									</Link>
								) : null}
								<UserDropdown />
							</>
						) : null}
						<ThemeSwitch userPreference={rootData.requestInfo.userPrefs.theme} />
					</div>
				</nav>
			</header>
		</>
	)
}
